import { create } from "zustand";
import type { ILocation } from "../types/types";

interface StoreState {
	center: ILocation;
	zoom: number;
	activeWindow: string;
	setCenter: (location: ILocation) => void;
	setZoom: (zoom: number) => void;
	setActiveWindow: (activeWindow: string) => void;
	// @ts-ignore
	// biome-ignore lint/suspicious/noExplicitAny: <explanation>
	handleMapPlaceSelected: (place: any) => void;
	detectLocation: () => void;
}

const useMapStore = create<StoreState>((set, get) => ({
	center: { lat: 47.7903272, lng: 13.514442 },
	activeWindow: "",
	zoom: 10,
	setCenter: (location) => set({ center: location }),
	setZoom: (zoom) => set({ zoom }),
	setActiveWindow: (activeWindow) => set({ activeWindow }),
	handleMapPlaceSelected: (place) => {
		const location = place?.geometry?.location ?? place?.location;
		if (location) {
			set({ center: { lat: location.lat(), lng: location.lng() }, zoom: 12 });
			return;
		}
		// geometry not returned (fields not specified in Autocomplete) — geocode via place_id or address
		// biome-ignore lint/suspicious/noExplicitAny: google maps types
		const G = (window as any).google?.maps;
		if (!G?.Geocoder) return;
		const geocoder = new G.Geocoder();
		const query = place?.place_id
			? { placeId: place.place_id }
			: { address: place?.formatted_address ?? place?.name, region: "at" };
		geocoder.geocode(query, (results: any, status: string) => {
			if (status === "OK" && results?.[0]?.geometry?.location) {
				const loc = results[0].geometry.location;
				set({ center: { lat: loc.lat(), lng: loc.lng() }, zoom: 12 });
			}
		});
	},
	detectLocation: () => {
		navigator.geolocation.getCurrentPosition(
			(position) => {
				set({
					center: {
						lat: position.coords.latitude,
						lng: position.coords.longitude,
					},
					zoom: 12,
				});
			},
			(error) => {
				console.log(error);
			},
		);
	},
}));

export default useMapStore;
